import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
  AbstractControl
} from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import * as Constants from '../../../models/Constants';
import {
  AlertMsg,
  errorObj,
  iconConfig,
  REGEX,
} from 'src/app/models/Constants';
import { CustBusService } from 'src/app/services/customer-search-bussiness-logic.service';
import { RootScopeService } from 'src/app/services/root-scope.service';
import { AlightTableComponent } from '../../common/alight-table/alight-table.component';
import { columnsModel } from 'src/app/models/customer.model';
import * as _ from 'lodash';
import { GenesysCloudService } from 'src/app/services/genesys-cloud.service';
import { LogService } from 'src/app/services/log.service';
import { AlightSmartSearchDropDownComponent } from 'src/app/components/common/alight-smart-search-drop-down/alight-smart-search-drop-down.component';
import { CustomerAccountBusinessLogicService } from '../../../services/customer-account-business-logic.service';
import {  MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import * as _moment from 'moment';
import { default as _rollupMoment } from 'moment';
import { CustomMomentDateAdapter } from 'src/app/models/customMomentDateAdapter';

declare var $: any;
const moment = _rollupMoment || _moment;
// added code to format date in text box- e.g - May-30-2023
export const MY_FORMATS = {
  parse: {
    dateInput: 'MMM-DD-YYYY',
  },
  display: {
    dateInput: 'MMM-DD-YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMM YYYY',
  },
};

@Component({
  selector: 'app-customer-search',
  templateUrl: './customer-search.component.html',
  styleUrls: ['./customer-search.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: CustomMomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ]
})
export class CustomerSearchComponent implements OnInit {
  iconConfig: object = iconConfig.bullHorn;
  alertConfig: object = errorObj;
  selectedRow;
  @ViewChild(AlightTableComponent) alightTable;
  @ViewChild(AlightSmartSearchDropDownComponent) alightSmartSearch;
  inboundMsg: string = Constants.INBOUND_CALL_ACCESS_ERRORMSG;
  AdditionalAccountChatMsg: string = Constants.Additional_Account_Chat_Msg;

  errorMsg = AlertMsg;
  customerSearchForm: FormGroup = new FormGroup({});
  public Columns: columnsModel[] = [
    { field: 'lastName', header: 'Last Name', width: 24 },
    { field: 'firstName', header: 'First Name', width: 24 },
    { field: 'address', header: 'Address', width: 40 },
    { field: 'dateOfBirth', header: 'Date of Birth', width: 10 },
    { field: 'nationalId', header: 'National ID', width: 10 },
    { field: 'employeeId', header: 'Emp ID', width: 10 },
    { field: 'postalCode', header: 'Postal Code', width: 10 },
  ];
  public dataSource: any = new MatTableDataSource();
  public clients: Array<any> = new Array<any>();
  public customers: Array<any> = new Array<any>();
  accountModal: any = 'additional';
  isModalOpen: boolean = false;
  public totalCount: string = Constants.DefaultTableRange;
  totalRecords!: number;
  isTotalCountMore: boolean = false;
  invalid = false;
  selectedValue: any;
  render: boolean = false;
  loaderType = Constants.LOADER_TYPE.CARD;
  clientId: any;
  public maxDate = new Date();

  constructor(
    private fb: FormBuilder,
    public rootService: RootScopeService,
    public customerService: CustBusService,
    private eRef: ElementRef,
    public genesysCloudService: GenesysCloudService,
    public logger: LogService,
    public custAccService: CustomerAccountBusinessLogicService
  ) {
    this.customerService.accessComponent(this);
    this.createForm();
  }

  ngOnInit(): void {
    this.customers = this.rootService.customerTypeData;
    this.rootService.customerTypeDrpDwn = 'ACH';
    this.customers = this.rootService.customerTypeData;
    // this.customerSearchForm.get('customerType')?.setValue(0);
    /** Below onUdpIdChange method called for  CCR1-7167*/
    this.onUdpIdChange('retainValues');
    this.liveCallFn();
    this.logger.log(this.customerService.clients);
    this.setTableData();
    this.openCallChatValidatePopup();
    if(this.customerSearchForm.get('clientId')?.value&&!this.rootService.activeCustTab.clientId)
    this.rootService.activeCustTab.clientId = this.customerSearchForm.get('clientId')?.value;
    this.custAccService.defaultServiceOnLoad();

    /** Below piece of code  explicitly handles clearing of customer search page on receiving Outbound call
     * (Specific scenario since navigation to customer-search page is skipped in case of outbound call already) ***/
    if (this.rootService.callChatReceived && this.rootService.isOutBoundCall) {
      this.rootService.callChatReceived = false;
      this.rootService.isOutBoundCall = false;
    }
    this.actionOnCallChatEnds();
    /* istanbul ignore next */
    setTimeout(() => {
      if (this.rootService.isLiveCall || this.rootService.isLiveChat) {
        if (!this.customerService.liveClient && this.rootService.isLiveChat && this.rootService.liveChatCTS.length == 1 &&
          !this.rootService.customDialogData.customClass) {
          this.customerService.liveClient = this.customerService.setChatClient();
        }
        this.liveCallFn();
        
      }
    }, 200);
  }

  actionOnCallChatEnds() {
    this.rootService.callChatEnds.subscribe((data) => {
      if (data == true) {
        this.clearAll();
        this.rootService.callChatEnds.next(false);
        this.customerSearchForm.get('clientName')?.enable();
      }
    });
  }

  onClientChange(event) {
    console.log("event", event)
    if (this.rootService.selectedClient != event?.['value']) {
      this.rootService.selectedClient = event?.['value'];
      this.totalRecords = -1
      this.resetTableData();
      let clientName = this.customerSearchForm.get('clientName')?.value;
      this.customerSearchForm.get('lastName')?.setValue('');
      this.customerSearchForm.get('firstName')?.setValue('');
      this.customerSearchForm.get('nationalId')?.setValue('');
      this.customerSearchForm.get('employeeId')?.setValue('');
      this.customerSearchForm.get('postalCode')?.setValue('');
      this.customerSearchForm.get('dateOfBirth')?.setValue('');

      //code changes
      this.customerSearchForm.get('lastName')?.markAsUntouched();
      this.customerSearchForm.get('lastName')?.markAsPristine();
      $('#txtCustomerForm')[0]?.reset();
      this.customerSearchForm.get('clientName')?.setValue(clientName);

    /** Below onUdpIdChange method called for  CCR1-7167*/
      this.onUdpIdChange('reset');


    }

    if (event == 'CLEAR') {
      /** handling click of clear All  */
      this.clientId = 'NA';
      this.rootService.clientInfoCard.clientInfoVSClientIdMap[this.clientId] = [];
    }


    if (event.value) {
      if(!this.rootService.activeCustTab.activeChat)
      this.rootService.activeCustTab.clientId = event.value;
      this.customerSearchForm?.get('clientId')?.setValue(event.value);
      this.custAccService.getClientInfoCardData(event.value, false, this);
      this.customerSearchForm?.get('clientId')?.setValue(event.value);
      this.custAccService.getClientInfoCardDefaultService(event.value);
    } else {
      this.clientId = 'NA';
      this.customerSearchForm?.get('clientId')?.setValue('NA');
      this.rootService.clientInfoCard.clientInfoVSClientIdMap[this.clientId] = [];
    }

  }


  /* istanbul ignore next */
  setTableData() {
    if (
      this.rootService.dataSource &&
      this.rootService.dataSource.filteredData.length != 0
    ) {
      /* istanbul ignore next */
      setTimeout(() => {
        this.dataSource = this.rootService.dataSource;
        this.customerService.setTableData(this, this.rootService.totalCount);
      }, 100);
    }
    if (this.rootService.customerFormValues) {
      this.customerSearchForm.patchValue(this.rootService.customerFormValues);
      this.rootService.customerFormValues = null;
    }
  }

  createForm() {
    this.createCustomerSearchForm(this.rootService.customerSearchForm.value);
  }

  /*set client value based on live call &live chat will 
  if there is no live interaction  previous selected client value  */
  /* istanbul ignore next */
  getClientId(data) {
    if (this.customerService.Gensysvalidation(this)) {
      if (!data['customerType']) {
        data['customerType'] = 'ACH';
      }
      /**LIVE Mode ON */
      if (this.rootService.isLiveCall) {
        return this.customerService.liveClient;
      } else {
        return this.customerService.setChatClient();
      }
    }
    else if (data['clientId']) {
      return data['clientId'] + '';
    }
    else return null;
  }

  createCustomerSearchForm(data) {
    try {
      this.logger.log({ 'Method createCustomerSearchForm called': data });
            /**Comment for CCR1-2695 */
      // let dateOfBirth = this.rootService.dateFormatter(
      //   data['dateOfBirth'],
      //   'MM/dd/YYYY'
      // );

      this.clientId = this.getClientId(data);
      this.customerSearchForm = this.fb.group({
        clientId: new FormControl(this.getClientId(data)),
        udpId: new FormControl(data['udpId'],[
          this.noSpecialCharactersValidator
           ]),
        customerType: new FormControl(data['customerType']),
        lastName: new FormControl(data['lastName'], [
          Validators.required,
          Validators.pattern(REGEX.character),
        ]),
        firstName: new FormControl(data['firstName']),
        // dateOfBirth: new FormControl(dateOfBirth, [
        //   Validators.pattern(REGEX.date),
        // ]),
        dateOfBirth: new FormControl<Date | null>(data['dateOfBirth']),
        nationalId: new FormControl(data['nationalId'], [
          Validators.minLength(4),
          Validators.pattern(REGEX.nospace),
        ]),
        employeeId: new FormControl(data['employeeId']),
        postalCode: new FormControl(data['postalCode']),
        clientName: new FormControl(data['clientName'], [
          Validators.required
        ])
      });
    } catch (error) {
      console.log(error)
    }
  }

  openCallChatValidatePopup() {
    /***For InBound Call ,Client Access validation *****/
    this.rootService.showInboundValidateMsg.subscribe((data) => {
      if (data) {
        this.rootService.openCustomDialog(
          Constants.INBOUND_CALL_ACCESS_ERRORMSG,
          'NA',
          '',
          Constants.CUSTOMER_SEARCH,
          '',
          Constants.GOT_IT_BUTTON_TYPE,
          'inbound-modal'
        );
      }
    });

    /***For InBound Chat ,Client Access validation *****/
    this.rootService.showChatValidateMsg.subscribe((data) => {
      if (data) {
        this.rootService.openCustomDialog(
          Constants.CHAT_ACCESS_ERRORMSG,
          'NA',
          '',
          Constants.CUSTOMER_SEARCH,
          '',
          Constants.GOT_IT_BUTTON_TYPE,
          'inbound-modal'
        );
      }
    });
  }

  // @ViewChild(MatSort) sort!: MatSort;
  // @ViewChild(MatPaginator) paginator!: MatPaginator;

  isHide: boolean = true;
  /* Set default form values
  fb:form builder*/

  public submit() {
    this.logger.log({
      'this.customerSearchForm': this.customerSearchForm,
      'this.customerSearchForm - conve': this.rootService.conversationId,
    });
    if (this.invalidForm()) return;
    else {
      /* istanbul ignore next */
      setTimeout(() => {
        $('#txtSearch')[0].focus();
      }, 100);

      const udpId = this.customerSearchForm?.get('udpId')?.value; 
   /** Added condition for CCR1-7167: 
     * When a user searches for a Customer Account using a UDP ID, 
     * it will directly open the customer account. Otherwise, it will display the customer account results table. */

      if (udpId) {
        let payLoad = {
          buttonName : Constants.buttonEnum.customerAccount,
          row: {
            udpId: udpId
          }
        };
        this.rowSelection(payLoad);
        
      } else {
        this.customerService.getSearchData(this.customerSearchForm.value, this);
      }


    }
  }

  /*Set Live call Details and if live call details not avaible set default value */
  /* istanbul ignore next */
  public liveCallFn() {
    if (this.customerService.Gensysvalidation(this)) {
      this.logger.log('Client validation true');
      this.customerSearchForm.get('customerType')?.setValue('ACH');
      if (this.rootService.isLiveCall) {
        this.customerSearchForm.get('clientName')?.disable();
        this.customerSearchForm
          .get('clientId')
          ?.setValue(this.customerService.liveClient);
        this.customerSearchForm
          .get('clientName')
          ?.setValue(this.customerService.getClientName(this.customerService.liveClient));
      }

      if (this.rootService.isLiveChat) {
      
        if (this.rootService.liveChatCTS.length < 2 ) {
          this.customerSearchForm.get('clientName')?.disable();
          this.customerSearchForm
            .get('clientId')
            ?.setValue(this.customerService.setChatClient());

          this.customerSearchForm
            .get('clientName')
            ?.setValue(this.customerService.getClientName(this.customerService.setChatClient()));
        } 
        else   if( !this.rootService.checkForUnsecuredChat()){ // added code to set unsecured tab client in search tab 
    
          this.customerSearchForm.get('clientName')?.disable();
          this.customerSearchForm
            .get('clientId')
            ?.setValue(this.customerService?.setUnknownTabClient());
            this.customerSearchForm
            .get('clientName')
            ?.setValue(this.customerService.getClientName(this.customerService.setUnknownTabClient()));
        }
        else {
          this.customerSearchForm.get('clientName')?.enable();          
          /***For multiple chats ,data retention */
          if (this.rootService.multipleChatCaseForClearingState)
            this.customerSearchForm
              .get('clientId')
              ?.setValue(this.rootService.customerSearchForm.value['clientId']);

          this.customerSearchForm
            .get('clientName')
            ?.setValue(this.customerService.getClientName(this.rootService.customerSearchForm.value['clientId']));
        }
      }
    }
  }

  /*Clear all Based on live call and off call*/
  /* istanbul ignore next */
  public clearAll() {
    /**Adding below line for clientInfo card clearing  */
    if (!this.rootService.isLiveCall && !this.rootService.isLiveChat)
      this.onClientChange('CLEAR');


    $('#txtCustomerForm')[0]?.reset();
    this.totalCount = Constants.DefaultTableRange;
    // this.customerSearchForm?.markAsUntouched();
    this.liveCallFn();
    // $('#Client')[0].focus();
    // }
    this.invalid = false;
    this.totalRecords = -1;
    this.rootService.totalCount = -1;
    this.rootService.scrollToTop();
    this.rootService.customerSearchForm = new FormGroup({});
    if (!this.rootService.isLiveCall && !this.rootService.isLiveChat) {
      this.customerSearchForm.get('clientName')?.enable();
      this.customerSearchForm.get('clientName')?.markAsUntouched();
      this.customerSearchForm.get('clientName')?.setValue('');
    }
    this.resetTableData();
  }
  /* istanbul ignore next */
  resetTableData() {
    this.alightTable?.clearAll();
    this.rootService.dataSource = new MatTableDataSource([]);
    this.dataSource = new MatTableDataSource([]);
  }
  /*end Clear all fn */

  /*Validation Functions  */
  public errorHandling = (control: string, error: string) => {
    return this.customerSearchForm.value.clientId
      ? this.customerSearchForm.controls[control].hasError(error)
      : false;
  };

  onClearSelection(clearFlag: boolean): void {
    if (clearFlag) {
      this.clearAll();
    }
  }

  /* istanbul ignore next */
  public onKeyUp(event, option) {
    switch (option) {
      case 'dateOfBirth':
        let DobVal = event.target.value;
        this.customerSearchForm.controls[option].markAsTouched();
        if (
          event.keyCode >= 48 &&
          event.keyCode <= 57 &&
          (DobVal?.length === 2 || DobVal?.length === 5)
        ) {
          this.customerSearchForm.controls['dateOfBirth'].setValue(
            DobVal + '/'
          );
        }
        break;

      default:
        if (event.target.value)
          this.customerSearchForm.controls[option].markAsTouched();

        break;
    }
  }
  /*Before form submit Check all validations  */
  public invalidForm() {
    let invalidForm = this.customerSearchForm.controls;
    this.invalid = false;
    for (let id in invalidForm) {
      /**Comment for CCR1-2695 */
      // if (
      //   id == 'dateOfBirth' &&
      //   invalidForm[id].value &&
      //   new Date() < new Date(invalidForm[id].value)
      // ) {
      //   invalidForm[id].setErrors({
      //     customError: { message: AlertMsg.dateOfBirth },
      //   });
      // }
      if (invalidForm[id].invalid) {
        this.invalid = true;
        // $('#' + id)[0].focus();
        return this.invalid;
      }
    }
    return this.invalid;
  }


  checkSearchDisable() {
    let clientName = this.customerSearchForm.get('clientName')?.value
    let clientId = this.getClientIdFromClientList(clientName);
    if (clientId) {
      return false;
    }
    return true;

  }


  /*Client Validation Base Focus */
  /* istanbul ignore next */
  onFocus(event) {
    if (
      this.customerSearchForm.value.clientId == 0 ||
      !this.customerSearchForm.value.clientId || this.customerSearchForm.value.clientName == ''
    ) {
      // $('#Client')[0].focus();
      this.customerSearchForm.get('clientName')?.markAsTouched();
      if (this.customerSearchForm.get('lastName')?.invalid) {
        this.customerSearchForm.get('lastName')?.markAsPristine();
        this.customerSearchForm.get('lastName')?.markAsUntouched();
      }
    }
  }

  /* istanbul ignore next */
  rowSelection(data) {
    this.customerService.parentData = null;
    this.customerService.openAdditonalAcc = null;
    this.selectedRow = data?.row;
    data.row.customerType = this.customerSearchForm?.value?.customerType || 'ACH';
    //data.row.customerType = this.rootService.isLiveCall && data.buttonName != Constants.buttonEnum.additionalAccount ? (this.customerSearchForm?.value?.customerType || 'ACH') : 'ACH';
    data.row.clientId = this.customerSearchForm?.value?.clientId;
    this.logger.log(data);
    if (data.buttonName == Constants.buttonEnum.additionalAccount) {
        if (this.rootService.fullySecuredCall()) {
          let addTab = this.rootService.customerTabs.find(
            (x) => x.additionalAccountId && (x.activeCall || x.activeChat)
          );
          this.customerService.openAdditonalAcc = {
            id: addTab?.additionalAccountId,
            conversationId: addTab?.conversationId,
          };

          if (this.rootService.activeChatOrCall() > 1) {
            this.multiChatCustPopup();
          } else if (this.customerService.openAdditonalAcc?.id) {
            this.closeAdditonalAcc();
          } else this.reasonForAdditionalPopUp();
        }
    }
    else if (this.rootService.checkMaxCustAccount() && data.buttonName != Constants.buttonEnum.replaceAccount) {
      this.customerService.showPopup();
      return;
    }
    else {
      if (data.buttonName == Constants.buttonEnum.customerAccount) {
        let previouslyOpenedTab = _.findIndex(
          this.rootService.customerTabs,
          (each) => each.conversationId == 'NA' && each.id == data?.row?.udpId
        );
        if (previouslyOpenedTab > 0) {
          return this.redirectToExAccount(
            this.rootService.customerTabs[previouslyOpenedTab]
              ?.customerSessionId
          );
        }
      }
 
      /**
       * CCR1-7167 *
       *  In below method we have pass this as a param so that when the customer account open 
       * we can clear customer search form data.
       **/
      this.customerService.getPersonData(data,null,this);
      this.rootService.custSearchLoader = true;
      // if (this.rootService.isLiveCall || this.rootService.isLiveChat) {
      //   let that = this;

      // }

        //this.clearAll();
      
      

    }

  }

  activeChatCustomers: any[] = [];
  /* istanbul ignore next */
  multiChatCustPopup() {
    this.activeChatCustomers = this.rootService.customerTabs.filter(
      (x) =>
        !x.additionalAccount &&
        x.activeChat &&
        x.clientId == this.customerSearchForm.value.clientId
    );

    if (this.activeChatCustomers?.length > 1) {
      this.accountModal = 'chat';
      this.isModalOpen = true;
      this.rootService.scrollToTop();
    } else this.findCustomer(this.activeChatCustomers[0]);
  }

  /**
   * @author Vamsi.pamidala
   * close the additional account need to check converstion id and udpid
   */
  /* istanbul ignore next */
  closeAdditonalAcc() {
    let existingData = this.customerService.getTabDetails(
      this.selectedRow.udpId,
      this.customerService.parentData
        ? this.customerService.parentData?.conversationId
        : this.rootService.conversationId
    );
    if (existingData?.customerSessionId)
      this.redirectToExAccount(existingData?.customerSessionId);
    else {
      this.customerService.mustCloseAddionalPopup();
      this.rootService.scrollToTop();
    }
  }

  /**
   * @author vamsi.pamidala
   * Below method for open reason for additional account and update id in primary account id and additional id
   */
  /* istanbul ignore next */
  reasonForAdditionalPopUp() {
    let existingData = this.customerService.getTabDetails(
      this.selectedRow.udpId,
      this.customerService.parentData
        ? this.customerService.parentData?.conversationId
        : this.rootService.conversationId
    );
    if (existingData?.customerSessionId)
      this.redirectToExAccount(existingData?.customerSessionId);
    else {
      this.accountModal = 'additional';
      this.isModalOpen = true;
      this.rootService.scrollToTop();
    }
  }

  @HostListener('document:click', ['$event'])
  clickOut(event) {

    if (
      !this.eRef.nativeElement.contains(event.target) &&
      !this.customerSearchForm.value.clientId
    ) {
      // $('#txtCustomerForm')[0].reset();
    }
  }

  inboundCallBtn() {
    this.rootService.showInboundValidateMsg = false;
  }

  /*
  @customerSessionId will handle redirect tab
  @ handle below functionality for redirect in research and same account trying to open in call/chat/outbound/callback  */
  /* istanbul ignore next */
  redirectToExAccount(customerSessionId) {
    this.customerService.updateActiveTabDetails(customerSessionId);
    this.rootService.customerLink = customerSessionId;
    this.customerService.routeToActiveTab(customerSessionId);
    return;
  }
  /* istanbul ignore next */
  buttonClick(data) {
    let type = data['type'];
    let buttonType = data['buttonType'];
    if (
      type == Constants.CLOSE_ADD_ACNT_BUTTON &&
      buttonType == Constants.CLOSE_ADD_ACNT_BUTTON
    ) {
      this.customerService.closeAddAccount();
      if (data?.msg == Constants.Additional_Account_Chat_Msg)
        this.reasonForAdditionalPopUp();
    }
  }
  /* istanbul ignore next */
  buttonEvent(event) {
    switch (event.btnName) {
      case Constants.buttonEnum.continue:
        this.isModalOpen = false;

        if (this.accountModal == 'chat') {
          this.findCustomer(event.customer);
        } else {
          this.customerService.parentData = this.customerService.parentData
            ? this.customerService.parentData
            : this.rootService.customerTabs.find(
              (x) => (x.activeCall || x.activeChat) && !x.additionalAccount
            );

          // this.customerService.getParentData(this.customerService.parentId);
          this.customerService.reasonForAdditional = {
            firstReason: event.primaryValue.label,
            secondReason: event.secondaryValue.label,
          };
          this.customerService.getPersonData({
            row: this.selectedRow,
            buttonName: Constants.buttonEnum.additionalAccount,
          });
          this.rootService.custSearchLoader = true;
        }
        if (event.btnName == Constants.buttonEnum.continue) {
          this.clearAll();
        }
        break;

      case Constants.buttonEnum.cancel:
        this.isModalOpen = false;
        break;
    }
  }

  /* istanbul ignore next */
  findCustomer(custId) {
    this.customerService.parentData = custId;
    //this.customerService.getParentData(custId);
    this.customerService.openAdditonalAcc = {
      id: custId?.additionalAccountId,
      conversationId: custId?.conversationId,
    };

    this.customerService.openAdditonalAcc?.id
      ? this.closeAdditonalAcc()
      : this.reasonForAdditionalPopUp();
  }
  /* istanbul ignore next */
  onClientDropDownChange(data) {
    if (this.rootService.selectedClient != data['value']) {
      this.rootService.selectedClient = data['value'];
      this.resetTableData();
      this.resetFormOnClientChange(data);
      // this.alightSmartSearch.filteredList = this.customerService.clients;
    }

  }
  resetFormOnClientChange(data) {
    this.createCustomerSearchForm({ clientId: data['value'] });
  }
  /* istanbul ignore next */
  ngOnDestroy() {
    clearTimeout(this.rootService.custSearchLoaderTimeoutId);
    this.rootService.custSearchLoader = false;
    this.rootService.showCustSearchLoaderMsg = false;
    this.logger.log({ cust: this.customerSearchForm });

    /** Below piece of code  explicitly handles clearing of customer search page on receiving call or chat ***/
    if (this.rootService.callChatReceived) {
      this.rootService.callChatReceived = false;
      return;
    }

    if (this.customerSearchForm.value['clientName'])
      this.rootService.customerSearchForm = this.customerSearchForm;

    if (
      this.rootService.isLiveChat &&
      this.rootService.liveChatCTS.length > 1
    ) {
      this.rootService.multipleChatCaseForClearingState = true;
    }

    this.rootService.dataSource = this.dataSource;
  }

  /* istanbul ignore next */
  getClientIdFromClientList(clientName) {

    let item = this.customerService.clients?.filter(
      a => a.clientName == clientName
    )
    return item[0]?.clientId;
  }
    /** Below method reset and disable the form-fields except Client field
     * on entering of UDP Id form-field
     * CCR1-7167
     * */ 

  onUdpIdChange(event: any): void {
    const udpIdValue = this.customerSearchForm.get('udpId')?.value;

    if (udpIdValue) {
      // Clear and disable another field if UDP ID has a value
      this.customerSearchForm.get('lastName')?.reset();
      this.customerSearchForm.get('firstName')?.reset();
      this.customerSearchForm.get('nationalId')?.reset();
      this.customerSearchForm.get('employeeId')?.reset();
      this.customerSearchForm.get('postalCode')?.reset();
      this.customerSearchForm.get('dateOfBirth')?.reset();
      this.customerSearchForm.get('lastName')?.disable();
      this.customerSearchForm.get('firstName')?.disable();
      this.customerSearchForm.get('nationalId')?.disable();
      this.customerSearchForm.get('employeeId')?.disable();
      this.customerSearchForm.get('postalCode')?.disable();
      this.customerSearchForm.get('dateOfBirth')?.disable();
    } else {
      // Enable the field if UDP ID is empty
      this.customerSearchForm.get('lastName')?.enable();
      this.customerSearchForm.get('firstName')?.enable();
      this.customerSearchForm.get('nationalId')?.enable();
      this.customerSearchForm.get('employeeId')?.enable();
      this.customerSearchForm.get('postalCode')?.enable();
      this.customerSearchForm.get('dateOfBirth')?.enable();
    }
  }

    /**
     * Below metod is Custom validator for no special characters which is used in form-field of UDP Id
     *  */ 
    noSpecialCharactersValidator(control: AbstractControl): { [key: string]: boolean } | null {
      const value = control.value || '';
      const specialCharPattern = /[!@#$%^&*(),.?":{}|<>]/g; 
  
      if (specialCharPattern.test(value)) {
        return { invalidSpecialChar: true };
      }
      return null;
    }
}
